/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';
import {
    withStyles,
    createTheme,
    ThemeProvider,
} from "@material-ui/core/styles";

import { Typography, Paper, Button } from '@material-ui/core'

import logo from '../../assets/sainapse_logo2.png'

const blue_theme = createTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc014e",
      },
    },
});

const styles = theme => ({})

class SignOut extends Component {
    state = {  } 

    getConfirmationText = () => {
        if (localStorage.getItem('logout_uri') !== "") {
            return (
                <Fragment>
                    <Typography style = {{marginTop : '20px'}} variant = 'h6' align = 'center'>You have successfully closed the current session. It's a good idea to close all browser windows.</Typography>
                    <Typography style = {{marginTop : '10px'}} variant = 'body2'>You can enter the application again by clicking the button below, or sign out of the application completely.(You will be asked for the login credentials next time you enter.)</Typography>
                </Fragment>
            )
        } else {
            return (
                <Typography style = {{marginTop : '20px'}} variant = 'h6' align = 'center'>You've signed out of your account. It's a good idea to close all browser windows.</Typography>
            )
        }
    }

    renderActions = () => {
        if (localStorage.getItem('logout_uri') !== "") {
            return (
                <Fragment>
                     <Button
                        style = {{marginTop : '10px'}}
                        variant = 'outlined'
                        color = 'primary'
                        size = 'small'
                        onClick = {() => window.open(window.location.origin, "_self")}
                    >Enter Again</Button>
                     <Button
                        style = {{marginTop : '10px'}}
                        variant = 'outlined'
                        color = 'secondary'
                        size = 'small'
                        onClick = {() => window.open(localStorage.getItem('logout_uri'), "_self")}
                    >Sign Out of Account</Button>
                </Fragment>
            )
        } else {
            return (
                <Button
                    style = {{marginTop : '10px'}}
                    variant = 'outlined'
                    color = 'primary'
                    size = 'small'
                    onClick = {() => window.open(window.location.origin, "_self")}
                >Login Again</Button>
            )
        }
    }

    render() { 
        return (
            <ThemeProvider theme = {blue_theme}>
                <div style = {{width : '100vw', height : '100vh', display : 'flex', flexDirection : 'column', justifyContent : 'center', alignItems : 'center'}}>
                    <Paper style = {{width : '250px', height : '150px', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center', backgroundColor : "#FFFFFF"}} elevation={4}>
                        <div style = {{display : 'flex', flexDirection : 'column', alignItems : 'center'}}>
                            <img style = {{width : '150px'}} src = {logo} alt = ""/>
                        </div>
                    </Paper>
                    {this.getConfirmationText()}
                    {this.renderActions()}
                </div>
            </ThemeProvider>
        );
    }
}
 
export default withStyles(styles)(SignOut);